// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkboxStyle_label__GGKnb {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.checkboxStyle_container__G8LDf {
  border: 2px solid #075e5b;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: #fff;
  position: relative;
  cursor: pointer;
}

.checkboxStyle_container__checked__NcokO {
  background-color: #075e5b;
}

.checkboxStyle_container__unchecked__pLpzo {
  background-color: #fff;
}

.checkboxStyle_input__2WPyd {
  appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.checkboxStyle_check__kazW4 {
  color: #fff;
  font-size: 13px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/checkboxStyle.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,eAAe;AACjB","sourcesContent":[".label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n}\n\n.container {\n  border: 2px solid #075e5b;\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  margin-right: 10px;\n  background-color: #fff;\n  position: relative;\n  cursor: pointer;\n}\n\n.container__checked {\n  background-color: #075e5b;\n}\n\n.container__unchecked {\n  background-color: #fff;\n}\n\n.input {\n  appearance: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.check {\n  color: #fff;\n  font-size: 13px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `checkboxStyle_label__GGKnb`,
	"container": `checkboxStyle_container__G8LDf`,
	"container__checked": `checkboxStyle_container__checked__NcokO`,
	"container__unchecked": `checkboxStyle_container__unchecked__pLpzo`,
	"input": `checkboxStyle_input__2WPyd`,
	"check": `checkboxStyle_check__kazW4`
};
export default ___CSS_LOADER_EXPORT___;
